import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import styled from 'styled-components';

import style from 'styles/styled-components/style';

const { Grid } = style;

export const BackgroundWrapper = styled.div`
	width: 100%;
	height: 100%;

	position: relative;
`;

export const Background = styled.div`
	width: 100%;
	height: 100%;
	padding: 0;
	background-color: ${({ theme }) => theme.colors.uplus.bg15};

	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const StickySectionFilter = styled.div<{
	_padding?: string;
}>`
	width: 100%;

	${({ _padding }) => _padding && `padding: ${_padding}`};
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border-bottom: 1px solid ${({ theme }) => theme.colors.gray.gray15};
`;

export const BodyWrapper = styled(OverlayScrollbarsComponent)`
	width: 100%;
	height: 100%;
	padding: 32px 0;

	display: flex;
	flex-direction: column;

	overflow: auto;
`;

export const BodyInnerWrapper = styled(Grid)`
	width: 1300px;
	padding: 0 32px;
	margin: 0 auto;
`;
